<script lang="ts">
const styles = _stylex_create({
  footer: {
    paddingBlock: '1rem',
    paddingInline: '1.5rem',
    textAlign: 'center',
  },
})
</script>
<script setup lang="ts">
import __MACROS__stylex_attrs from "/vue-macros/define-stylex/stylex-attrs";
import { create as _stylex_create, props as _stylex_props } from '@stylexjs/stylex'
import { RouterLink } from 'vue-router'


</script>

<template>
  <footer v-bind="__MACROS__stylex_attrs(_stylex_props(styles.footer))">
    <RouterLink to="/about">
      About
    </RouterLink>
  </footer>
</template>
